import { c as _c } from "react/compiler-runtime";
import { InlineAlert } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import AnimatedContainer from '@/components/animated-container';
import type { TransformedDocument } from '@/components/entities/components/details/hooks/use-documents';
import type useEntityVault from '@/components/entities/hooks/use-entity-vault';
import AgentExtractionData from './components/agent-extraction-data';
import AiImageScores from './components/ai-image-scores';
import ConfidenceScores from './components/confidence-scores';
import ExtractedDocumentData from './components/extracted-document-data';
import IdentityData from './components/identity-data';
import RawJsonData from './components/raw-json-data';
import useAgentExtractionResult from './hooks/use-agent-extraction-result';
export type DrawerContentProps = {
  document: TransformedDocument;
  vault: ReturnType<typeof useEntityVault>;
};
const DrawerContent = t0 => {
  const $ = _c(35);
  const {
    document,
    vault
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "fieldset.documents.details"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  const {
    extractions,
    hasExtractionData
  } = useAgentExtractionResult(document.id);
  const isFixtureData = document.fixtureResult && document.fixtureResult !== "real";
  let t2;
  if ($[1] !== vault.data?.vault) {
    t2 = vault.data?.vault || {};
    $[1] = vault.data?.vault;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const vaultData = t2;
  let t3;
  if ($[3] !== document.completedVersion) {
    t3 = document.completedVersion?.toString();
    $[3] = document.completedVersion;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const activeDocumentVersion = t3;
  let t4;
  if ($[5] !== isFixtureData || $[6] !== t) {
    t4 = isFixtureData && <InlineAlert variant="info">{t(_temp)}</InlineAlert>;
    $[5] = isFixtureData;
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== document) {
    t5 = <ConfidenceScores document={document} />;
    $[8] = document;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== document.uploads) {
    t6 = <AiImageScores uploads={document.uploads} />;
    $[10] = document.uploads;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== extractions || $[13] !== hasExtractionData) {
    t7 = hasExtractionData && <AgentExtractionData extractions={extractions} />;
    $[12] = extractions;
    $[13] = hasExtractionData;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== hasExtractionData || $[16] !== t7) {
    t8 = <AnimatedContainer isExpanded={hasExtractionData}>{t7}</AnimatedContainer>;
    $[15] = hasExtractionData;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  const t9 = activeDocumentVersion ?? "";
  let t10;
  if ($[18] !== document.kind || $[19] !== t9 || $[20] !== vaultData) {
    t10 = <ExtractedDocumentData vault={vaultData} documentType={document.kind} activeDocumentVersion={t9} />;
    $[18] = document.kind;
    $[19] = t9;
    $[20] = vaultData;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== document) {
    t11 = <IdentityData document={document} />;
    $[22] = document;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== document || $[25] !== vaultData) {
    t12 = <RawJsonData vault={vaultData} document={document} />;
    $[24] = document;
    $[25] = vaultData;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t10 || $[28] !== t11 || $[29] !== t12 || $[30] !== t4 || $[31] !== t5 || $[32] !== t6 || $[33] !== t8) {
    t13 = <>{t4}{t5}{t6}{t8}{t10}{t11}{t12}</>;
    $[27] = t10;
    $[28] = t11;
    $[29] = t12;
    $[30] = t4;
    $[31] = t5;
    $[32] = t6;
    $[33] = t8;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  return t13;
};
export default DrawerContent;
function _temp($) {
  return $.isFixtureAlert;
}